module.exports = __webpack_public_path__ + "static/media/yelp.ff263991.svg";